module.exports = __webpack_public_path__ + "static/media/clooger-4.86460d7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cases/clooger-4.jpg
// module id = 373
// module chunks = 0